(() => {
  const cache = new Map();
  const linear = value => { const n=value/255; return n<=.04045?n/12.92:((n+.055)/1.055)**2.4; };
  const channels=Float32Array.from({length:256},(_,i)=>linear(i));
  function inkFor(light, previous) {
    if (previous==='white' && light<.22) return 'white';
    if (previous==='black' && light>.14) return 'black';
    return light<.179?'white':'black';
  }
  function photoRect(image, box, style) {
    if (!['contain','cover'].includes(style.objectFit)) return box;
    const scale=(style.objectFit==='cover'?Math.max:Math.min)(box.width/image.naturalWidth,box.height/image.naturalHeight);
    const width=image.naturalWidth*scale,height=image.naturalHeight*scale,pos=style.objectPosition.split(' ');
    const fraction=v=>v?.endsWith('%')?parseFloat(v)/100:['left','top'].includes(v)?0:['right','bottom'].includes(v)?1:.5;
    return {left:box.left+(box.width-width)*fraction(pos[0]),top:box.top+(box.height-height)*fraction(pos[1]),width,height};
  }
  function readPhoto(source, changed) {
    const key=source.currentSrc||source.src;
    if(!key)return {};
    if(cache.has(key))return cache.get(key);
    const entry={};cache.set(key,entry);
    if(cache.size>32)cache.delete(cache.keys().next().value);
    const image=new Image();image.crossOrigin='anonymous';
    image.onload=()=>{
      try{
        const canvas=document.createElement('canvas');canvas.width=Math.min(384,image.naturalWidth);canvas.height=Math.max(1,Math.round(canvas.width*image.naturalHeight/image.naturalWidth));
        const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0,canvas.width,canvas.height);
        const pixels=ctx.getImageData(0,0,canvas.width,canvas.height).data;
        entry.width=canvas.width;entry.height=canvas.height;entry.light=new Float32Array(canvas.width*canvas.height);
        for(let i=0;i<entry.light.length;i++){const p=i*4,a=pixels[p+3]/255;entry.light[i]=a*(.2126*channels[pixels[p]]+.7152*channels[pixels[p+1]]+.0722*channels[pixels[p+2]])+(1-a);}
        changed();
      }catch{entry.failed=true;}
    };
    image.onerror=()=>{entry.failed=true;};image.src=key;return entry;
  }
  function lightAt(photos,x,y) {
    let value=1;
    for(const {clip:c,rect:r,data:d} of photos){
      if(x<c.left||x>=c.right||y<c.top||y>=c.bottom||!d.light)continue;
      const u=(x-r.left)/r.width,v=(y-r.top)/r.height;
      if(u<0||u>=1||v<0||v>=1)continue;
      const px=Math.max(0,Math.min(d.width-1,u*d.width-.5)),py=Math.max(0,Math.min(d.height-1,v*d.height-.5));
      const x0=Math.floor(px),y0=Math.floor(py),x1=Math.min(x0+1,d.width-1),y1=Math.min(y0+1,d.height-1),fx=px-x0,fy=py-y0;
      value=(d.light[y0*d.width+x0]*(1-fx)+d.light[y0*d.width+x1]*fx)*(1-fy)+(d.light[y1*d.width+x0]*(1-fx)+d.light[y1*d.width+x1]*fx)*fy;
    }
    return value;
  }
  function regionLight(photos,box) {
    let total=0;
    for(let row=0;row<5;row++)for(let col=0;col<11;col++)total+=lightAt(photos,box.left+box.width*(col+.5)/11,box.top+box.height*(row+.5)/5);
    return total/55;
  }
  function controlLight(photos,box) {
    const values=[];
    for(let row=0;row<7;row++)for(let col=0;col<15;col++)values.push(lightAt(photos,box.left+box.width*(col+.5)/15,box.top+box.height*(row+.5)/7));
    values.sort((a,b)=>a-b);
    return values[Math.floor(values.length/2)];
  }
  function dotLight(photos,box) {
    const values=[];
    for(let y=-2;y<=2;y++)for(let x=-2;x<=2;x++){
      if(x*x+y*y>4)continue;
      values.push(lightAt(photos,box.left+box.width*(.5+x/5),box.top+box.height*(.5+y/5)));
    }
    values.sort((a,b)=>a-b);
    return values[Math.floor(values.length/2)];
  }
  function linePixels(photos,box,width,pixels) {
    for(let i=0;i<width;i++){
      const x=box.left+(i+.5)*box.width/width,y=box.bottom-.5;
      const light=(lightAt(photos,x-.5,y)+2*lightAt(photos,x,y)+lightAt(photos,x+.5,y))/4;
      const ink=Math.round(255*Math.max(0,Math.min(1,(.19-light)/.022)));
      const p=i*4;pixels[p]=pixels[p+1]=pixels[p+2]=ink;pixels[p+3]=255;
    }
  }
  function controlPixels(photos,box,sprite,pixels) {
    for(const point of sprite.points){
      const light=lightAt(photos,box.left+point.x*box.width,box.top+point.y*box.height);
      const ink=Math.round(255*Math.max(0,Math.min(1,(.19-light)/.022)));
      pixels[point.p]=pixels[point.p+1]=pixels[point.p+2]=ink;
      pixels[point.p+3]=point.alpha;
    }
  }
  function controlSprite(control,box,changed) {
    const scale=Math.min(window.devicePixelRatio||1,2),width=Math.max(1,Math.round(box.width*scale)),height=Math.max(1,Math.round(box.height*scale));
    const source=control.currentSrc||control.src;
    const entry={width,height,source,points:null};
    const canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;
    const context=canvas.getContext('2d',{willReadFrequently:true});
    if(!context)return entry;
    const done=()=>{
      try{
        const rgba=context.getImageData(0,0,width,height).data,points=[];
        for(let i=0;i<width*height;i++)if(rgba[i*4+3])points.push({p:i*4,x:(i%width+.5)/width,y:(Math.floor(i/width)+.5)/height,alpha:rgba[i*4+3]});
        entry.points=points;changed();
      }catch{entry.failed=true;}
    };
    if(control.matches?.('.isitglow-menu-toggle-lines')){
      context.fillStyle='#000';
      for(const line of control.querySelectorAll('.isitglow-menu-toggle-line')){
        const style=getComputedStyle(line),left=parseFloat(style.left)||0,top=parseFloat(style.top)||0,width=parseFloat(style.width)||box.width,height=parseFloat(style.height)||1.4;
        context.beginPath();context.roundRect(left*scale,top*scale,width*scale,height*scale,height*scale/2);context.fill();
      }
      done();return entry;
    }
    let url=source;
    if(control.tagName?.toLowerCase()==='svg'){
      let markup=new XMLSerializer().serializeToString(control);
      if(!markup.includes('xmlns='))markup=markup.replace('<svg','<svg xmlns="http://www.w3.org/2000/svg"');
      url='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(markup);
    }
    if(!url)return entry;
    const image=new Image();image.crossOrigin='anonymous';
    image.onload=()=>{context.drawImage(image,0,0,width,height);done();};
    image.onerror=()=>{entry.failed=true;};image.src=url;return entry;
  }
  function init(){
    const header=document.querySelector('.section-header'),gallery=document.querySelector('main media-gallery'),wrapper=header?.querySelector('.header-wrapper');
    if(!wrapper||!gallery||header.dataset.glowContrastReady)return;
    header.dataset.glowContrastReady='true';header.dataset.glowProductInk='black';
    wrapper.querySelectorAll('.glow-product-contrast').forEach(el=>el.remove());
    const painters=new Map();
    const mobile=matchMedia('(max-width:749px)'),states=new WeakMap();
    const line=document.createElement('canvas');line.className='glow-header-contrast-line';line.setAttribute('aria-hidden','true');wrapper.append(line);
    const lineContext=line.getContext('2d',{alpha:false});
    let lineBuffer=null,images=[],controls=[],dots=[],frame=0,until=0;
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const moving=()=>{until=performance.now()+220;schedule();};
    const collect=()=>{
      controls=[...header.querySelectorAll('.header__heading-logo,.custom-cart-icon,.header__icon--search .icon-search,.isitglow-menu-toggle-lines')];
      images=[...gallery.querySelectorAll('.product__media img')];
      for(const image of images)if(image.naturalWidth)readPhoto(image,moving);
      dots=[...gallery.querySelectorAll('[data-isitglow-polene-dot]')];moving();
    };
    const commit=(el,light,attr)=>{
      const ink=inkFor(light,states.get(el));
      states.set(el,ink);
      if(el.getAttribute(attr)!==ink)el.setAttribute(attr,ink);
      return ink;
    };
    function update(now=performance.now()){
      frame=0;
      if(document.hidden||!mobile.matches)return;
      const g=gallery.getBoundingClientRect(),h=wrapper.getBoundingClientRect(),photos=[];
      const dotBoxes=dots.map(dot=>dot.getBoundingClientRect()),controlBoxes=controls.map(control=>control.getBoundingClientRect());
      for(let i=0;i<controls.length;i++){
        const control=controls[i],box=controlBoxes[i];
        if(!box.width||!box.height)continue;
        let painter=painters.get(control);
        const scale=Math.min(window.devicePixelRatio||1,2),width=Math.round(box.width*scale),height=Math.round(box.height*scale),source=control.currentSrc||control.src;
        if(!painter){
          const canvas=document.createElement('canvas');canvas.className='glow-control-contrast';canvas.setAttribute('aria-hidden','true');
          const context=canvas.getContext('2d');
          if(!context)continue;
          painter={canvas,context};painters.set(control,painter);
        }
        if(!painter.sprite||painter.sprite.width!==width||painter.sprite.height!==height||painter.sprite.source!==source){
          painter.sprite=controlSprite(control,box,moving);
          painter.canvas.width=width;painter.canvas.height=height;painter.buffer=painter.context.createImageData(width,height);
        }
      }
      for(const image of images){
        if(!image.isConnected||!image.naturalWidth)continue;
        const box=image.getBoundingClientRect();
        if(!box.width||!box.height||box.right<=0||box.left>=innerWidth)continue;
        const style=getComputedStyle(image),slide=image.closest('.product__media-item'),ss=slide&&getComputedStyle(slide);
        if(style.display==='none'||style.visibility==='hidden'||+style.opacity===0||ss&&(ss.display==='none'||ss.visibility==='hidden'||+ss.opacity===0))continue;
        const media=image.closest('.product__media')?.getBoundingClientRect()||box,slideBox=slide?.getBoundingClientRect()||media;
        const clip={left:Math.max(0,media.left,slideBox.left),right:Math.min(innerWidth,media.right,slideBox.right),top:Math.max(g.top,media.top,slideBox.top),bottom:Math.min(g.bottom,media.bottom,slideBox.bottom)};
        if(clip.right<=clip.left||clip.bottom<=clip.top)continue;
        photos.push({rect:photoRect(image,box,style),clip,data:readPhoto(image,moving)});
      }
      for(let i=0;i<dots.length;i++){
        const dot=dots[i],box=dotBoxes[i];
        if(!box.width||!box.height)continue;
        const ink=commit(dot,dotLight(photos,box),'data-glow-dot-ink');
        if(dot.getAttribute('data-glow-dot-contrast')!=='true')dot.setAttribute('data-glow-dot-contrast','true');
        const color=ink==='white'?'#fff':'#000';
        if(dot.style.getPropertyValue('--glow-dot-ink')!==color)dot.style.setProperty('--glow-dot-ink',color);
      }
      if(!document.querySelector('cart-drawer.active,#cart-notification.active')){
        const overlay=document.body.hasAttribute('data-glow-menu-open')||header.querySelector('details[open],.ig-search-is-open')||document.querySelector('product-modal[open]');
        const intersects=!overlay&&g.bottom>h.top&&g.top<h.bottom;
        header.dataset.glowProductContrast=overlay?'overlay':intersects?'gallery':'paper';
        for(let i=0;i<controls.length;i++){
          const control=controls[i],rect=controlBoxes[i];
          if(!rect.width||!rect.height)continue;
          commit(control,intersects?controlLight(photos,rect):1,'data-glow-control-ink');
          const painter=painters.get(control),ready=!!painter?.sprite.points?.length;
          if(painter){
            const canvas=painter.canvas;
            if(!canvas.isConnected)wrapper.append(canvas);
            const active=intersects&&ready;
            if(active){
              const placement=`left:${rect.left-h.left}px;top:${rect.top-h.top}px;width:${rect.width}px;height:${rect.height}px`;
              if(canvas.getAttribute('style')!==placement)canvas.setAttribute('style',placement);
              controlPixels(photos,rect,painter.sprite,painter.buffer.data);
              painter.context.putImageData(painter.buffer,0,0);
            }
            canvas.setAttribute('data-active',active?'true':'false');
            control.setAttribute('data-glow-spatial',active?'true':'false');
          }
        }
        commit(header,intersects?regionLight(photos,{left:h.left,top:h.bottom-4,width:h.width,height:4}):1,'data-glow-product-ink');
        if(lineContext&&h.width>0){
          const width=Math.max(1,Math.ceil(h.width*Math.min(window.devicePixelRatio||1,2)));
          if(!lineBuffer||line.width!==width){line.width=width;line.height=1;lineBuffer=lineContext.createImageData(width,1);}
          linePixels(intersects?photos:[],h,width,lineBuffer.data);
          lineContext.putImageData(lineBuffer,0,0);
        }
      }
      const animating=gallery.getAnimations?.({subtree:true}).some(a=>a.playState==='running')||header.getAnimations?.({subtree:true}).some(a=>a.playState==='running');
      if(now<until||animating)schedule();
    }
    window.addEventListener('scroll',moving,{passive:true});window.addEventListener('resize',collect,{passive:true});
    window.visualViewport?.addEventListener('resize',moving,{passive:true});window.visualViewport?.addEventListener('scroll',moving,{passive:true});
    gallery.addEventListener('load',collect,true);gallery.addEventListener('scroll',moving,{passive:true,capture:true});
    for(const name of ['touchstart','touchmove','touchend','pointermove','slideChanged','transitionrun','animationstart'])gallery.addEventListener(name,moving,{passive:true});
    new MutationObserver(records=>{
      if(records.some(r=>r.type==='childList'||['src','srcset'].includes(r.attributeName)))collect();
      else if(records.some(r=>r.attributeName!=='style'||!r.target.matches?.('[data-isitglow-polene-dot]')))moving();
    }).observe(gallery,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','aria-current','src','srcset']});
    new MutationObserver(records=>{if(records.some(r=>r.target!==line&&!r.target.matches?.('.glow-control-contrast')))moving();}).observe(header,{subtree:true,attributes:true,attributeFilter:['open','class','style']});
    new MutationObserver(moving).observe(document.body,{attributes:true,attributeFilter:['class','data-glow-menu-open']});
    document.querySelectorAll('cart-drawer,#cart-notification,product-modal').forEach(el=>new MutationObserver(moving).observe(el,{attributes:true,attributeFilter:['class','open']}));
    new ResizeObserver(moving).observe(header);document.addEventListener('glow:media-updated',collect);document.addEventListener('visibilitychange',moving);window.addEventListener('pageshow',collect);collect();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
